import { get, set } from 'lodash';
export function migrateBodyPaddings(message) {
    const bodyGlobalCssKey = 'data.composerData.styles.css.so-global-body';
    const bodyGlobalCss = get(message, bodyGlobalCssKey);
    // Inside region builders/renderers we need to know
    // if current campaign was created using v1 or v2 engine.
    // Currently the logo region should behave as in v1.
    const isCreatedUsingV1Engine = [
        bodyGlobalCss.paddingLeft,
        bodyGlobalCss.paddingRight,
    ].some((_) => !!_);
    if (isCreatedUsingV1Engine) {
        set(message, 'data.composerData.styles.v1', true);
    }
    const leftSpacing = bodyGlobalCss.paddingLeft || '0px';
    const rightSpacing = bodyGlobalCss.paddingRight || '0px';
    const regionGlobalCssKey = 'data.composerData.styles.css.so-global-region';
    const regionGlobalCss = get(message, regionGlobalCssKey);
    regionGlobalCss.marginLeft = regionGlobalCss.marginLeft || leftSpacing;
    regionGlobalCss.marginRight = regionGlobalCss.marginRight || rightSpacing;
    bodyGlobalCss.paddingLeft = '';
    bodyGlobalCss.paddingRight = '';
    return message;
}
//# sourceMappingURL=migrate-body-paddings.js.map